import { Stethoscope, Video, Salad } from "lucide-react";
import { CHANNELS } from "../data/content";
import { Reveal, SectionHeading } from "./Reveal";

const ICONS = [Stethoscope, Video, Salad];

const PracticeChannels = () => (
  <section id="practice" data-testid="practice-channels-section" className="py-20 sm:py-28">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <SectionHeading number="01" title="Practice Channels & Consultations" testId="practice-channels-heading" />
      <div className="grid sm:grid-cols-2 xl:grid-cols-3 gap-5">
        {CHANNELS.map((c, i) => {
          const Icon = ICONS[i];
          return (
            <Reveal key={c.title} delay={i * 0.08}>
              <article
                data-testid={`practice-channel-card-${i}`}
                className="group h-full bg-white border border-[#0D3B3E]/10 p-7 flex flex-col transition-[transform,border-color,box-shadow] duration-500 hover:-translate-y-1.5 hover:border-[#0D9488]/50 hover:shadow-[0_20px_50px_rgba(13,59,62,0.08)]"
              >
                <div className="flex items-start justify-between mb-8">
                  <span className="flex items-center justify-center w-11 h-11 rounded-full bg-[#0D3B3E]/[0.05] text-[#0D9488] group-hover:bg-[#0D9488] group-hover:text-white transition-colors duration-500">
                    <Icon className="w-5 h-5" />
                  </span>
                  <span className="text-[9px] font-mono tracking-[0.2em] text-[#0D9488] border border-[#0D9488]/30 rounded-full px-2.5 py-1">
                    {c.tag}
                  </span>
                </div>
                <h3 className="font-display font-semibold text-xl text-[#0D3B3E] leading-snug">{c.title}</h3>
                <p className="mt-3 text-sm text-slate-600 leading-relaxed flex-1">{c.desc}</p>
                <p className="mt-6 pt-4 border-t border-[#0D3B3E]/10 text-[10px] font-mono tracking-[0.2em] text-slate-500">
                  {c.meta}
                </p>
              </article>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);

export default PracticeChannels;
